import React from 'react'

const GroupDetailsContext = React.createContext()

function GroupDetailsContextProvider(props) {
  const [audit_entities_attributes, setGroupDetails] = React.useState([
    {
      entity_id: '',
      entity_name: '',
      audit_entity_field_attributes: {field_id: '', field_name: ''},
      audit_entity_filters_attributes: [],
      audit_entity_auto_update_fields_attributes: [],
      audit_entity_auto_update_fields_values: [],
      audit_entity_user_fields_attributes: [],
    },
  ])
  const [allow_auto_update_fields, setAllowAutoUpdateField] = React.useState(false)
  const [allow_user_update_fields, setAllowUserUpdateField] = React.useState(false)
  const [allow_user_without_edit_permission, setAllowUserWithoutEditPermission] = React.useState(
    false
  )
  const [user_field, setUserField] = React.useState({})
  const resetGroupsDetails = () => {
    setGroupDetails([
      {
        entity_id: '',
        entity_name: '',
        audit_entity_field_attributes: {field_id: '', field_name: ''},
        audit_entity_filters_attributes: [],
        audit_entity_auto_update_fields_attributes: [],
        audit_entity_auto_update_fields_values: [],
        audit_entity_user_fields_attributes: [],
      },
    ])
    setAllowAutoUpdateField(false)
    setAllowUserUpdateField(false)
    setAllowUserWithoutEditPermission(false)
    setUserField({})
  }
  const value = {
    audit_entities_attributes,
    allow_auto_update_fields,
    allow_user_update_fields,
    allow_user_without_edit_permission,
    user_field,

    setGroupDetails,
    setAllowAutoUpdateField,
    setAllowUserUpdateField,
    resetGroupsDetails,
    setAllowUserWithoutEditPermission,
    setUserField,
  }

  // [B]
  return <GroupDetailsContext.Provider value={value}>{props.children}</GroupDetailsContext.Provider>
}

const GroupDetailsContextConsumer = GroupDetailsContext.Consumer

export {GroupDetailsContext, GroupDetailsContextProvider, GroupDetailsContextConsumer}
